import { Companion_instance1txg8t7ewhdy9 as Companion_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Primitives.mjs';
import {
  serializerodflzzf6s3fp as serializer,
  serializer1hu9wv9at41ww as serializer_0,
  serializer1r0h5yakm679b as serializer_1,
  serializer1tw0a8bv7lkga as serializer_2,
} from '../builtins/BuiltinSerializers.mjs';
import { InlinePrimitiveDescriptor3i6ccn1a4fw94 as InlinePrimitiveDescriptor } from './InlineClassDescriptor.mjs';
import {
  _ULong___get_data__impl__fggpzb2bbucljk081qt as _ULong___get_data__impl__fggpzb,
  ULong3f9k7s38t3rfp as ULong,
  _ULong___init__impl__c78o9k4z3cjzifecv6 as _ULong___init__impl__c78o9k,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  IntCompanionObject_instance38ap4zil98hon as IntCompanionObject_instance,
  ByteCompanionObject_instance1i09zkznh3bs3 as ByteCompanionObject_instance,
  ShortCompanionObject_instancekdrujyym9g7v as ShortCompanionObject_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import {
  _UInt___get_data__impl__f0vqqw2j5mttix8w0l0 as _UInt___get_data__impl__f0vqqw,
  UInt1hthisrv6cndi as UInt,
  _UInt___init__impl__l7qpdl2xbmh7to8lpd7 as _UInt___init__impl__l7qpdl,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  _UByte___get_data__impl__jof9qr23gcv767stjfh as _UByte___get_data__impl__jof9qr,
  UBytep4j7r1t64gz1 as UByte,
  _UByte___init__impl__g9hnc43bwrjlqz9k9id as _UByte___init__impl__g9hnc4,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import {
  _UShort___get_data__impl__g0245313795p1x5hw5 as _UShort___get_data__impl__g0245,
  UShort26xnqty60t7le as UShort,
  _UShort___init__impl__jigrne3vu9egv7mch1k as _UShort___init__impl__jigrne,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ULongSerializerClass;
function ULongSerializer() {
  if (ULongSerializerClass === VOID) {
    class $ {
      constructor() {
        ULongSerializer_instance = this;
        this.b27_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer(Companion_instance));
      }
      h1m() {
        return this.b27_1;
      }
      c27(encoder, value) {
        var tmp = encoder.f1s(this.b27_1);
        // Inline function 'kotlin.ULong.toLong' call
        var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
        tmp.z1r(tmp$ret$0);
      }
      i1m(encoder, value) {
        return this.c27(encoder, value instanceof ULong() ? value.nu_1 : THROW_CCE());
      }
      d27(decoder) {
        // Inline function 'kotlin.toULong' call
        var this_0 = decoder.v1q(this.b27_1).p1q();
        return _ULong___init__impl__c78o9k(this_0);
      }
      j1m(decoder) {
        return new (ULong())(this.d27(decoder));
      }
    }
    initMetadataForObject($, 'ULongSerializer', VOID, VOID, [KSerializer()]);
    ULongSerializerClass = $;
  }
  return ULongSerializerClass;
}
var ULongSerializer_instance;
function ULongSerializer_getInstance() {
  if (ULongSerializer_instance === VOID)
    new (ULongSerializer())();
  return ULongSerializer_instance;
}
var UIntSerializerClass;
function UIntSerializer() {
  if (UIntSerializerClass === VOID) {
    class $ {
      constructor() {
        UIntSerializer_instance = this;
        this.e27_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_0(IntCompanionObject_instance));
      }
      h1m() {
        return this.e27_1;
      }
      f27(encoder, value) {
        var tmp = encoder.f1s(this.e27_1);
        // Inline function 'kotlin.UInt.toInt' call
        var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
        tmp.y1r(tmp$ret$0);
      }
      i1m(encoder, value) {
        return this.f27(encoder, value instanceof UInt() ? value.cu_1 : THROW_CCE());
      }
      g27(decoder) {
        // Inline function 'kotlin.toUInt' call
        var this_0 = decoder.v1q(this.e27_1).o1q();
        return _UInt___init__impl__l7qpdl(this_0);
      }
      j1m(decoder) {
        return new (UInt())(this.g27(decoder));
      }
    }
    initMetadataForObject($, 'UIntSerializer', VOID, VOID, [KSerializer()]);
    UIntSerializerClass = $;
  }
  return UIntSerializerClass;
}
var UIntSerializer_instance;
function UIntSerializer_getInstance() {
  if (UIntSerializer_instance === VOID)
    new (UIntSerializer())();
  return UIntSerializer_instance;
}
var UByteSerializerClass;
function UByteSerializer() {
  if (UByteSerializerClass === VOID) {
    class $ {
      constructor() {
        UByteSerializer_instance = this;
        this.h27_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_1(ByteCompanionObject_instance));
      }
      h1m() {
        return this.h27_1;
      }
      i27(encoder, value) {
        var tmp = encoder.f1s(this.h27_1);
        // Inline function 'kotlin.UByte.toByte' call
        var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
        tmp.w1r(tmp$ret$0);
      }
      i1m(encoder, value) {
        return this.i27(encoder, value instanceof UByte() ? value.rt_1 : THROW_CCE());
      }
      j27(decoder) {
        // Inline function 'kotlin.toUByte' call
        var this_0 = decoder.v1q(this.h27_1).m1q();
        return _UByte___init__impl__g9hnc4(this_0);
      }
      j1m(decoder) {
        return new (UByte())(this.j27(decoder));
      }
    }
    initMetadataForObject($, 'UByteSerializer', VOID, VOID, [KSerializer()]);
    UByteSerializerClass = $;
  }
  return UByteSerializerClass;
}
var UByteSerializer_instance;
function UByteSerializer_getInstance() {
  if (UByteSerializer_instance === VOID)
    new (UByteSerializer())();
  return UByteSerializer_instance;
}
var UShortSerializerClass;
function UShortSerializer() {
  if (UShortSerializerClass === VOID) {
    class $ {
      constructor() {
        UShortSerializer_instance = this;
        this.k27_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_2(ShortCompanionObject_instance));
      }
      h1m() {
        return this.k27_1;
      }
      l27(encoder, value) {
        var tmp = encoder.f1s(this.k27_1);
        // Inline function 'kotlin.UShort.toShort' call
        var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
        tmp.x1r(tmp$ret$0);
      }
      i1m(encoder, value) {
        return this.l27(encoder, value instanceof UShort() ? value.yu_1 : THROW_CCE());
      }
      m27(decoder) {
        // Inline function 'kotlin.toUShort' call
        var this_0 = decoder.v1q(this.k27_1).n1q();
        return _UShort___init__impl__jigrne(this_0);
      }
      j1m(decoder) {
        return new (UShort())(this.m27(decoder));
      }
    }
    initMetadataForObject($, 'UShortSerializer', VOID, VOID, [KSerializer()]);
    UShortSerializerClass = $;
  }
  return UShortSerializerClass;
}
var UShortSerializer_instance;
function UShortSerializer_getInstance() {
  if (UShortSerializer_instance === VOID)
    new (UShortSerializer())();
  return UShortSerializer_instance;
}
//region block: exports
export {
  UByteSerializer_getInstance as UByteSerializer_getInstance25gdez4j7umj8,
  UIntSerializer_getInstance as UIntSerializer_getInstance20bbdzhnv2szq,
  ULongSerializer_getInstance as ULongSerializer_getInstance1ldnpnjc28qim,
  UShortSerializer_getInstance as UShortSerializer_getInstance22daskttsd0mq,
};
//endregion

//# sourceMappingURL=ValueClasses.mjs.map
